import instance from './instance';

export const servicenowRecordSelectOptions = (slug, tableName, recordAttributes, attribute) =>
  instance.get(`/servicenow/record_select_options`, {
    params: { tableName, ...recordAttributes, attribute },
  });

export const searchServicenowRecords = query =>
  instance.get(`/servicenow/search_records`, {
    params: { query },
  });

export const updateServicenowRecord = (tableName, recordId, recordAttributes) =>
  instance.put(`/servicenow/update_record`, { tableName, recordId, recordAttributes });
